module.exports = __webpack_public_path__ + "static/img/2.d82915f.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/iot/eng/2.png
// module id = UP/d
// module chunks = 0